<template>
  <v-menu
      v-model="menu"
      :close-on-content-click="false"
      offset-y
      bottom
    >
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        dark
        icon
        :title="messages.clientsButtonTitle"
        small
        class="mx-1"
      >
        <v-icon>supervisor_account</v-icon>
      </v-btn>
    </template>
      <v-card
        width="200px"
        class="pa-2"
      >
        <h3
          class="text-center"
        >{{ messages.clientsButtonTitle }}</h3>
        <ul>
          <template
            v-for="(client, index) in clients"
          >
            <li
              :key="index"
              class="subtitle-1"
              v-text="client"
            >
            </li>
          </template>
        </ul>
      </v-card>
    </v-menu>
</template>

<script>
export default {
  name: 'PoClientsList',
  data: () => ({
    menu: false,
    messages: {
      clientsButtonTitle: 'Clients',
    },
  }),
  props: {
    clients: {
      type: Array,
      required: true,
    },
  },
};
</script>
